const ITEMS = [
  "FLAP YOUR WAY TO GLORY",
  "BEND IT LIKE FLAPPY",
  "DON'T HIT THE POST",
  "MULTIPLAYER LEADERBOARDS",
  "FREE TO PLAY",
  "ONE THUMB. ENDLESS GLORY.",
];

export default function Marquee() {
  const row = (
    <>
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-display text-2xl sm:text-3xl tracking-wider text-white/90 px-6">
            {t}
          </span>
          <span className="w-2.5 h-2.5 rounded-full bg-gold shrink-0" aria-hidden="true" />
        </span>
      ))}
    </>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-line bg-turf/60 py-5 -rotate-1 scale-[1.02]"
    >
      <div className="marquee-track flex w-max">
        <div className="flex">{row}</div>
        <div className="flex" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
}
